"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * LiBat Gestion
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class UserApi extends runtime.BaseAPI {
    /**
     * Get current user
     */
    getCurrentUserRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/user/me`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IUserFromJSON(jsonValue));
        });
    }
    /**
     * Get current user
     */
    getCurrentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCurrentUserRaw();
            return yield response.value();
        });
    }
    /**
     * Get user by id
     */
    getUserByIdRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getUserById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IUserFromJSON(jsonValue));
        });
    }
    /**
     * Get user by id
     */
    getUserById(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserByIdRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieve the user list
     * Get all users
     */
    getUsersRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/users`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.IUserFromJSON));
        });
    }
    /**
     * Retrieve the user list
     * Get all users
     */
    getUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUsersRaw();
            return yield response.value();
        });
    }
    /**
     * Logs user into the system
     */
    loginRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.username === null || requestParameters.username === undefined) {
                throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling login.');
            }
            if (requestParameters.password === null || requestParameters.password === undefined) {
                throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling login.');
            }
            const queryParameters = {};
            if (requestParameters.username !== undefined) {
                queryParameters['username'] = requestParameters.username;
            }
            if (requestParameters.password !== undefined) {
                queryParameters['password'] = requestParameters.password;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/login`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.LoginResponseFromJSON(jsonValue));
        });
    }
    /**
     * Logs user into the system
     */
    login(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.loginRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Logs out current logged in user session
     */
    logoutRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/logout`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Logs out current logged in user session
     */
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.logoutRaw();
        });
    }
}
exports.UserApi = UserApi;
